var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalculator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.394,
    height: 27.192,
    viewBox: "0 0 20.394 27.192",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calculator",
    transform: "translate(-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2464",
    "data-name": "Trazado 2464",
    d: "M19,1.7a1.7,1.7,0,0,1,1.7,1.7V23.793a1.7,1.7,0,0,1-1.7,1.7H5.4a1.7,1.7,0,0,1-1.7-1.7V3.4A1.7,1.7,0,0,1,5.4,1.7ZM5.4,0A3.4,3.4,0,0,0,2,3.4V23.793a3.4,3.4,0,0,0,3.4,3.4H19a3.4,3.4,0,0,0,3.4-3.4V3.4A3.4,3.4,0,0,0,19,0Z",
    transform: "translate(0)",
    fill: "#003082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2465",
    "data-name": "Trazado 2465",
    d: "M4,2.85A.85.85,0,0,1,4.85,2h11.9a.85.85,0,0,1,.85.85v3.4a.85.85,0,0,1-.85.85H4.85A.85.85,0,0,1,4,6.249Zm0,6.8a.85.85,0,0,1,.85-.85h1.7a.85.85,0,0,1,.85.85v1.7a.85.85,0,0,1-.85.85H4.85a.85.85,0,0,1-.85-.85Zm0,5.1a.85.85,0,0,1,.85-.85h1.7a.85.85,0,0,1,.85.85v1.7a.85.85,0,0,1-.85.85H4.85a.85.85,0,0,1-.85-.85Zm0,5.1A.85.85,0,0,1,4.85,19h1.7a.85.85,0,0,1,.85.85v1.7a.85.85,0,0,1-.85.85H4.85a.85.85,0,0,1-.85-.85Zm5.1-10.2a.85.85,0,0,1,.85-.85h1.7a.85.85,0,0,1,.85.85v1.7a.85.85,0,0,1-.85.85h-1.7a.85.85,0,0,1-.85-.85Zm0,5.1a.85.85,0,0,1,.85-.85h1.7a.85.85,0,0,1,.85.85v1.7a.85.85,0,0,1-.85.85h-1.7a.85.85,0,0,1-.85-.85Zm0,5.1a.85.85,0,0,1,.85-.85h1.7a.85.85,0,0,1,.85.85v1.7a.85.85,0,0,1-.85.85h-1.7a.85.85,0,0,1-.85-.85Zm5.1-10.2a.85.85,0,0,1,.85-.85h1.7a.85.85,0,0,1,.85.85v1.7a.85.85,0,0,1-.85.85h-1.7a.85.85,0,0,1-.85-.85Zm0,5.1a.85.85,0,0,1,.85-.85h1.7a.85.85,0,0,1,.85.85v6.8a.85.85,0,0,1-.85.85h-1.7a.85.85,0,0,1-.85-.85Z",
    transform: "translate(1.399 1.399)",
    fill: "#003082"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.cbba7d628efec853cfb906647c3238ca.svg";
export { ForwardRef as ReactComponent };